
const styles = theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(../../assets/welcome1.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  listItemRoot: {
    padding: theme.spacing(2),
  },
  listItemText: {
    color: "black",
  },
  video: {
    maxWidth: 250,
  },
  centerBoxGrid: {
    textAlign: 'center',
    maxWidth: 700,
  },
  adminExpContainer: {
    textAlign: 'center',
    maxWidth: 600,
  },
  panelTitle: {
    marginTop: 6,
    marginLeft: theme.spacing(1),
  },
})

export default styles
